import moment from "moment"
import { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import { Backend } from "../services/Backend";

export default function NewsItem({ data, linkTo }) {
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        Backend.download(`attachment/${data.photo}`)
            .then(res => {
                data.photoLink =  URL.createObjectURL(res);
                setIsLoading(false);
            })
    }, []);

    function getTextFromFirstTag(htmlString) {
        const match = htmlString.match(/<[^>]+>([^<]*)<\/[^>]+>/);
        
        return match ? match[1] : null;
    }

    if(isLoading) {
        return <></>
    }

    return <div className="mb-[40px] flex gap-3 ">
        <img src={data.photoLink} className="w-[150px]"/>
        <div className="w-[85%]">
            <Link to={linkTo}><b className="text-2xl text-black">{data.title}</b></Link>
            <br/>
            <span className="">{moment(data.uploadDate).local().format("YYYY-MM-DD")}</span>
            <p>{getTextFromFirstTag(data.description).split('. ')[0]} <a href={`/news/${data.id}`}>Read more</a></p>
        </div>
    </div>

}